import IconHome from "../icons/IconHome"

// eslint-disable-next-line import/no-default-export
export default function BottomNavigationBar() {
  const items = [
    { label: 'test', icon: <IconHome width={30} height={30} /> },
    { label: 'test', icon: <IconHome width={30} height={30} /> },
    { label: 'test', icon: <IconHome width={30} height={30} /> },
    { label: 'test', icon: <IconHome width={30} height={30} /> },
    { label: 'test', icon: <IconHome width={30} height={30} /> },
  ]

  return (<ul className="fixed bottom-0 left-0 right-0 w-full flex flex-row justify-center  items-center align-middle text-center  z-[999999]">
    {items.map(item => <li className="relative w-[20%] bg-white h-14 justify-center items-center align-middle text-[-webkit-center]">
      {item.icon}
    </li>)}


  </ul>)



}